import styles from './CuiLabel.module.css';

/**
 * CUI-warning label — REQUIRED on every free-text notes / comms field (compliance
 * boundary: metadata only, no controlled content). See AGENTS.md "Compliance boundary".
 */
export function CuiLabel() {
    return (
        <p className={styles.cui} role="note">
            ⚠ Metadata only — no CUI/ITAR/CDI content. Part numbers, dates, quantities, and brief
            summaries only; never drawing/spec content.
        </p>
    );
}
